// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user-box-input{
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 20%;
}

.user-box-input input {
    width: 100%;
    padding: 10px 0;
    font-size: 16px;
    color: #505050;
    margin-bottom: 30px;
    border: none;
    border-bottom: 2px solid #003757;
    border-right: 2px solid #003757;
    outline: none;
    background: transparent;
  }
  
  .user-box-input .label-input {
    position: absolute;
    top: 15px;
    left: 0;
    padding: 10px 0;
    font-size: 18px;
    font-weight: bolder;
    color: #003757;
    pointer-events: none;
    transition: .5s;
  }
  
  .user-box-input input:focus ~ .label-input,
  .user-box-input input:valid ~ .label-input {
    top: -10px;
    left: 0;
    color: #003757;
    font-size: 12px;
  }

  .user-box-input .labelSelector {
    position: absolute;
    top: -25px;
    z-index: 2;
    left: 0;
    padding: 10px 0;
    font-size: 18px;
    font-weight: bolder;
    color: #003757;
    pointer-events: none;
    transition: .5s;
  }
  .inpit-admin-msg-error{
    color: #ff4646;
    position: absolute;
    left:0;
    /* top:10% */
    bottom: 20%;
    background-color: rgba(255, 211, 211, 0.64);
    width: 99%;
    text-align: center;
    border: 2px solid #ff4646;
    border-radius: 0px 0px 5px 5px;
    
    border-top: none;

  }`, "",{"version":3,"sources":["webpack://./src/components/styles/InputAdmin.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,WAAW;AACf;;AAEA;IACI,WAAW;IACX,eAAe;IACf,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,YAAY;IACZ,gCAAgC;IAChC,+BAA+B;IAC/B,aAAa;IACb,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,eAAe;IACf,eAAe;IACf,mBAAmB;IACnB,cAAc;IACd,oBAAoB;IACpB,eAAe;EACjB;;EAEA;;IAEE,UAAU;IACV,OAAO;IACP,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,UAAU;IACV,OAAO;IACP,eAAe;IACf,eAAe;IACf,mBAAmB;IACnB,cAAc;IACd,oBAAoB;IACpB,eAAe;EACjB;EACA;IACE,cAAc;IACd,kBAAkB;IAClB,MAAM;IACN,YAAY;IACZ,WAAW;IACX,2CAA2C;IAC3C,UAAU;IACV,kBAAkB;IAClB,yBAAyB;IACzB,8BAA8B;;IAE9B,gBAAgB;;EAElB","sourcesContent":[".user-box-input{\r\n    position: relative;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    width: 100%;\r\n    height: 20%;\r\n}\r\n\r\n.user-box-input input {\r\n    width: 100%;\r\n    padding: 10px 0;\r\n    font-size: 16px;\r\n    color: #505050;\r\n    margin-bottom: 30px;\r\n    border: none;\r\n    border-bottom: 2px solid #003757;\r\n    border-right: 2px solid #003757;\r\n    outline: none;\r\n    background: transparent;\r\n  }\r\n  \r\n  .user-box-input .label-input {\r\n    position: absolute;\r\n    top: 15px;\r\n    left: 0;\r\n    padding: 10px 0;\r\n    font-size: 18px;\r\n    font-weight: bolder;\r\n    color: #003757;\r\n    pointer-events: none;\r\n    transition: .5s;\r\n  }\r\n  \r\n  .user-box-input input:focus ~ .label-input,\r\n  .user-box-input input:valid ~ .label-input {\r\n    top: -10px;\r\n    left: 0;\r\n    color: #003757;\r\n    font-size: 12px;\r\n  }\r\n\r\n  .user-box-input .labelSelector {\r\n    position: absolute;\r\n    top: -25px;\r\n    z-index: 2;\r\n    left: 0;\r\n    padding: 10px 0;\r\n    font-size: 18px;\r\n    font-weight: bolder;\r\n    color: #003757;\r\n    pointer-events: none;\r\n    transition: .5s;\r\n  }\r\n  .inpit-admin-msg-error{\r\n    color: #ff4646;\r\n    position: absolute;\r\n    left:0;\r\n    /* top:10% */\r\n    bottom: 20%;\r\n    background-color: rgba(255, 211, 211, 0.64);\r\n    width: 99%;\r\n    text-align: center;\r\n    border: 2px solid #ff4646;\r\n    border-radius: 0px 0px 5px 5px;\r\n    \r\n    border-top: none;\r\n\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
